(function () {
  var ZOOM = 2.5;
  var PANEL_SIZE = 420;
  var GAP = 20;

  var panel = null;
  var activeImg = null;

  function supportsHoverZoom() {
    return window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches;
  }

  function ensurePanel() {
    if (panel) return panel;
    panel = document.createElement('div');
    panel.className = 'zb-hover-zoom-panel';
    document.body.appendChild(panel);
    return panel;
  }

  function ensureLens(container) {
    var lens = container.querySelector(':scope > .zb-hover-zoom-lens');
    if (lens) return lens;
    lens = document.createElement('div');
    lens.className = 'zb-hover-zoom-lens';
    var computed = window.getComputedStyle(container);
    if (computed.position === 'static') {
      container.style.position = 'relative';
    }
    container.appendChild(lens);
    return lens;
  }

  function hiResSrc(img) {
    var src = img.currentSrc || img.src;
    try {
      var url = new URL(src, window.location.href);
      url.searchParams.set('width', '2048');
      return url.href;
    } catch (e) {
      return src;
    }
  }

  function positionPanel(imgRect) {
    ensurePanel();
    var top = imgRect.top;
    var left = imgRect.right + GAP;
    var maxLeft = window.innerWidth - PANEL_SIZE - 8;

    if (left > maxLeft) {
      left = imgRect.left - PANEL_SIZE - GAP;
    }
    if (left < 8) {
      left = Math.max(8, maxLeft);
    }

    var maxTop = window.innerHeight - PANEL_SIZE - 8;
    if (top > maxTop) top = Math.max(8, maxTop);
    if (top < 8) top = 8;

    panel.style.top = top + 'px';
    panel.style.left = left + 'px';
  }

  function hide() {
    if (panel) {
      panel.style.opacity = '0';
      panel.style.visibility = 'hidden';
    }
    var lenses = document.querySelectorAll('.zb-hover-zoom-lens');
    for (var i = 0; i < lenses.length; i++) {
      lenses[i].style.opacity = '0';
    }
    activeImg = null;
  }

  function handleMove(e, container) {
    if (!supportsHoverZoom()) {
      hide();
      return;
    }

    var img = container.querySelector('img.product-media__image');
    if (!img) return;

    var rect = img.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return;

    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;

    if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
      return;
    }

    ensurePanel();
    if (activeImg !== img) {
      activeImg = img;
      panel.style.backgroundImage = 'url(' + hiResSrc(img) + ')';
    }

    var lens = ensureLens(container);
    var lensW = Math.min(rect.width, PANEL_SIZE / ZOOM);
    var lensH = Math.min(rect.height, PANEL_SIZE / ZOOM);
    var lensX = Math.max(0, Math.min(rect.width - lensW, x - lensW / 2));
    var lensY = Math.max(0, Math.min(rect.height - lensH, y - lensH / 2));

    lens.style.width = lensW + 'px';
    lens.style.height = lensH + 'px';
    lens.style.transform = 'translate(' + lensX + 'px, ' + lensY + 'px)';
    lens.style.opacity = '1';

    positionPanel(rect);
    panel.style.backgroundSize = (rect.width * ZOOM) + 'px ' + (rect.height * ZOOM) + 'px';
    panel.style.backgroundPosition = (-lensX * ZOOM) + 'px ' + (-lensY * ZOOM) + 'px';
    panel.style.opacity = '1';
    panel.style.visibility = 'visible';
  }

  function bind(container) {
    if (container.dataset.zbHoverZoomBound) return;
    container.dataset.zbHoverZoomBound = '1';
    container.addEventListener('mousemove', function (e) {
      handleMove(e, container);
    });
    container.addEventListener('mouseleave', hide);
  }

  function scan() {
    var containers = document.querySelectorAll('.product-media-container');
    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      if (container.closest('.dialog-zoomed-gallery')) continue;
      if (!container.querySelector('img.product-media__image')) continue;
      bind(container);
    }
  }

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  window.addEventListener('load', scan);
  window.addEventListener('resize', function () {
    if (!supportsHoverZoom()) hide();
  });

  var mo = new MutationObserver(function () {
    window.requestAnimationFrame(scan);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  scan();
})();
